import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  connect() {
    this.element.classList.remove('preload')

    // Remove widows from text
    document.querySelectorAll('.no-widow').forEach((el) => {
      el.innerHTML = el.textContent.replace(/\s(?=[^\s]*$)/g, '&nbsp;')
    })
  }

  disableTransitions() {
    this.element.classList.add('preload')
    clearTimeout(this.resizeTimer)

    this.resizeTimer = setTimeout(() => {
      this.element.classList.remove('preload')
    }, 250)
  }
}
